module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/pricing.40d2e7bd.svg";